import React, { useRef, useEffect } from 'react';
import { Chip, Box, useTheme, SvgIcon, GlobalStyles } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCello } from '../../context/CelloContext';

interface ReferralButtonProps {}

const ReferralButton: React.FC<ReferralButtonProps> = () => {
  const { isCelloBooted } = useCello();
  const { t } = useTranslation();
  const theme = useTheme();
  const chipRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (chipRef.current) {
      // The 'cello' attribute might be for Cello SDK to find/style the button.
      // We keep it here, assuming CelloInitializer makes it visible.
      chipRef.current.toggleAttribute('cello', true);
    }
  }, []);

  // Control overall rendering based on Cello's boot status from context
  if (!isCelloBooted) {
    return null; // Don't render the button if Cello is not booted
  }

  const celloWidgetStyles = {
    // Target the direct parent of .cello-1qoplec
    ':has(> .cello-1qoplec)': {
      position: 'relative',
    },
    '.cello-1qoplec': {
      position: 'absolute',
      bottom: '10px !important',
      top: 'unset !important',
      right: 'unset !important',
      left: 'unset !important',
    },
  };

  return (
    <>
      <GlobalStyles styles={celloWidgetStyles} />
      <Box sx={{ px: 1.5, mb: 2 }}>
        <Chip
          component="li"
          ref={chipRef}
          icon={<img src="/assets/icons/share2.svg" alt={t('referral.inviteFriends')} style={{ width: '1.2rem', height: '1.2rem' }} />}
          label={t('referral.inviteFriends')}
          id="celloLauncher"
          className="celloLauncher"
          sx={{ // display: 'none', // CelloInitializer now handles display via showCelloLauncherWithRetry. If that fails, button won't show.
            // If isCelloBooted is false, this component returns null anyway.
            // If isCelloBooted is true, CelloInitializer's showCelloLauncherWithRetry is responsible for 'display: flex'
            minHeight: '40px',
            width: '100%',
            py: 1.25,
            borderRadius: 1,
            justifyContent: 'flex-start',
            cursor: 'pointer',
            backgroundColor: theme.palette.primary.main,
            color: '#ffffff',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
            '& .MuiChip-icon': {
              color: '#ffffff',
              marginLeft: 1,
              display: 'flex',
              alignItems: 'top',
            },
            '& .MuiChip-label': {
              padding: '0 12px',
              fontSize: '0.875rem',
              fontWeight: 600,
              letterSpacing: '0.01em',
            }
          }}
        />
      </Box>
    </>
  );
};

export default ReferralButton;
